<template>
  <div>
    <v-menu
      bottom
      :left="esquerda"
      :right="direita"
      offset-y
      open-on-hover
      transition="scale-transition"
      :origin="ajustarPosicionamentoDoComponente"
      min-width="300px"
      max-width="300px"
    >
      <template v-slot:activator="{ on }">
        <v-icon v-on="on">mdi-information</v-icon>
      </template>
      <v-card color="#7e7e7e" >
        <v-card-text class="py-2">
          <h3 class="titulos texto-branco">{{titulo}}</h3>
          <v-divider class="white mb-1 mt-1"></v-divider>
          <span class="listas texto-branco" v-html="texto">{{texto}}</span>
        </v-card-text>
      </v-card>
    </v-menu>
  </div>
</template>
<script>
export default {
  data(){
    return{
      esquerda: true,
      direita: false
    }
  },
  props: {
    titulo: {
      type: String,
      default: ""
    },
    texto: {
      type: String,
      default: ""
    },
    posicao: {
      type: String,
      default: "esquerda"
    }
  },
  computed: {
    ajustarPosicionamentoDoComponente(){
      var vm = this
      if(this.posicao == "esquerda") {
        vm.esquerda = true;
        vm.direita = false;
        return "top right";
      }else {
        vm.esquerda = false;
        vm.direita = true;
        return "top left";
      }
    }
  }
};
</script>

<style>
.texto-branco {
  color: white !important;
  font-weight: normal;
}
</style>